import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconCashOn = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-cash-on_svg__a)"
      d="M21.527 4.375c.95 0 1.723.773 1.723 1.688v9c0 .949-.773 1.687-1.723 1.687H5.812c-.949 0-1.687-.773-1.687-1.688v-9c0-.949.738-1.687 1.688-1.687h15.714Zm-7.875 9.563c1.582 0 2.813-1.477 2.813-3.376 0-1.863-1.266-3.374-2.813-3.374-1.582 0-2.812 1.511-2.812 3.375 0 1.898 1.23 3.374 2.812 3.374Zm5.098 6.187a.833.833 0 0 0 .844-.844.856.856 0 0 0-.844-.843H4.969a2.52 2.52 0 0 1-2.532-2.532V7.47a.855.855 0 0 0-.843-.844.833.833 0 0 0-.844.844v8.437a4.187 4.187 0 0 0 4.219 4.219H18.75Z"
    />
    <defs>
      <linearGradient
        id="icon-cash-on_svg__a"
        x1={23.5}
        x2={6.028}
        y1={3}
        y2={25.326}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconCashOn;
